import { ref } from 'vue'

// Module-level singletons so useTelephone (a plain composable) can drive the
// same popup UI that every phone input shares and hand the chosen country
// back through an onSelect callback.
const isOpen = ref(false)
const options = ref({
  title: 'Select country',
  searchPlaceholder: 'Search',
  closeLabel: 'Close',
  noResultsLabel: 'No results found',
  rows: [],
})

let selectFn = null

export function useCountryPicker() {
  function open(payload = {}) {
    options.value = {
      title: payload.title || 'Select country',
      searchPlaceholder: payload.searchPlaceholder || 'Search',
      closeLabel: payload.closeLabel || 'Close',
      noResultsLabel: payload.noResultsLabel || 'No results found',
      rows: Array.isArray(payload.rows) ? payload.rows : [],
    }
    selectFn = typeof payload.onSelect === 'function' ? payload.onSelect : null
    isOpen.value = true
  }

  function choose(iso2) {
    if (typeof selectFn === 'function') {
      try {
        selectFn(iso2)
      } catch (error) {
        console.error('[useCountryPicker] selection callback failed', iso2, error)
      }
    }
    close()
  }

  function close() {
    isOpen.value = false
    selectFn = null
  }

  return { isOpen, options, open, choose, close }
}